/**
 * Portal product names — browser document title and in-app headers.
 * Providers keep Healthcare Provider Portal; SM and Record Reviewer / PHA surfaces use their own names.
 */
export const PortalProductName = {
  PROVIDER: 'Healthcare Provider Portal',
  SERVICE_MEMBER: 'Service Member Portal',
  PHA: 'PHA Portal',
} as const;

export type PortalProductNameType =
  (typeof PortalProductName)[keyof typeof PortalProductName];

/** Default / provider-facing product name (nav, home, auth copy). */
export const PORTAL_PRODUCT_NAME_FULL = PortalProductName.PROVIDER;
